(function () {
    'use strict';

    angular
        .module('app')
        .factory('EntityFieldEmbeddedEntity', EntityFieldEmbeddedEntityFactory);

    EntityFieldEmbeddedEntityFactory.$inject = ['EntityFieldScalar'];

    function EntityFieldEmbeddedEntityFactory(EntityFieldScalar) {

        /**
         * @constructor
         * @name EntityFieldEmbeddedEntity
         */
        function EntityFieldEmbeddedEntity(name, value) {
            EntityFieldScalar.call(this, name, value);
        }

        EntityFieldEmbeddedEntity.prototype = Object.create(EntityFieldScalar.prototype);
        EntityFieldEmbeddedEntity.prototype.constructor = EntityFieldEmbeddedEntity;

        EntityFieldEmbeddedEntity.prototype.toString = function () {
            return '[object EntityFieldEmbeddedEntity]';
        };

        return EntityFieldEmbeddedEntity;
    }
})();